/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_OverlineInputs */

const en_mk_publish_overline = /** @type {(inputs: Mk_Publish_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FROM PREVIEW TO APP`)
};

const id_mk_publish_overline = /** @type {(inputs: Mk_Publish_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DARI PRATINJAU KE APLIKASI`)
};

/**
* | output |
* | --- |
* | "FROM PREVIEW TO APP" |
*
* @param {Mk_Publish_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_overline = /** @type {((inputs?: Mk_Publish_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_overline(inputs)
	return en_mk_publish_overline(inputs)
});